import type { ReUploadConfig, ReuploadPolicy } from 'garaje/models/custom-user-document-template';

export default function buildReUploadConfig(policy: ReuploadPolicy, days: string, date: Date | null): ReUploadConfig {
  switch (policy) {
    case 'always':
      return { policy: 'always' };
    case 'never':
      return { policy: 'never' };
    case 'after_days':
      return { policy: 'after_days', days: parseInt(days, 10) || 365 };
    case 'on_expiration':
      return { policy: 'on_expiration' };
    case 'on_date_yearly':
      return {
        policy: 'on_date_yearly',
        month: date ? date.getMonth() + 1 : undefined,
        day: date ? date.getDate() : undefined,
      };
    default:
      return { policy: 'never' };
  }
}
